// Asks the LinkedInClient backend for a signed OAuth "state" for the signed-in user.
//
// The state is what LinkedIn sends back to the callback, and the callback stores the
// LinkedIn tokens under the identity inside it. A signed state means nobody can start a
// connection that stores LinkedIn tokens under somebody else's email.
//
// - The endpoint lives in the same Function App as the accounts endpoint, so its URL is
//   derived from REACT_APP_LINKEDIN_PROFILE_URL (no new variable to configure) and apiFetch
//   adds the access token because the host is already a Feelim host.
// - Fail-safe: if anything goes wrong the plain email is returned, which is exactly what the
//   app sent before. A backend that still accepts it keeps working; one that enforces answers
//   with its own error page instead of connecting.
import { apiFetch } from "./apiFetch";

const ACCOUNTS_SEGMENT = /linkedingetaccounts$/i;

export const linkedInStateUrl = (profileUrl = process.env.REACT_APP_LINKEDIN_PROFILE_URL) => {
  try {
    const url = new URL(profileUrl);
    if (!ACCOUNTS_SEGMENT.test(url.pathname)) return null;
    url.pathname = url.pathname.replace(ACCOUNTS_SEGMENT, "linkedinauthstate");
    url.search = "";
    url.hash = "";
    return url.toString();
  } catch {
    return null;
  }
};

export const getLinkedInState = async (email) => {
  const base = linkedInStateUrl();
  if (base) {
    try {
      const res = await apiFetch(base);
      if (res.ok) {
        const data = await res.json();
        if (typeof data?.state === "string" && data.state) return data.state;
      } else {
        console.warn("LinkedIn state request failed:", res.status);
      }
    } catch (err) {
      console.warn("LinkedIn state request failed:", err?.name || "error");
    }
  }
  return email;
};